import React, { useState } from 'react';
import './SFCVotePanel.less';
import { Modal, Input, message } from 'antd';
const { TextArea } = Input;
import { VoteQuestionPO, CommonResultint } from '@src/services';
import pkBtn from '../../../../assets/pk-btn.png';

export interface ISFCVotePanelProps {
  voteInfo?: VoteQuestionPO;
  doVote: (
    voteOptionId: number,
    voteQuestionId: number,
    callback: (res: CommonResultint) => void
  ) => void;
  submitCommon: (val: string, type: boolean) => void;
  finishVote: () => void;
}
type Props = ISFCVotePanelProps;

export function SFCVotePanel(props: Props) {
  const { voteInfo = {}, doVote, submitCommon, finishVote } = props;
  const { voteOptions } = voteInfo;
  const [modalVisible, setModalVisible] = useState(false);
  const [viewPort, setViewPort] = useState(false);
  const [index, setIndex] = useState(0);
  const [comment, setComment] = useState('');
  const closeModal = () => {
    setModalVisible(false);
    finishVote();
  };

  const voteCallback = (res: CommonResultint) => {
    if (res.code === 0) {
      // message.success('投票成功!');
      // setModalVisible(true);
    } else {
      message.error(res.message);
    }
  };

  const handleOk = () => {
    if (!comment || !comment.trim()) {
      message.error('观点不能为空哦');
      return;
    }
    doVote(
      (voteOptions && voteOptions[index].voteOptionId) || 0,
      (voteOptions && voteOptions[index].voteQuestionId) || 0,
      voteCallback
    );
    submitCommon(comment, viewPort);
    closeModal();
  };
  const handleCancel = () => {
    closeModal();
  };

  const voteAction = (index: number, type: boolean) => {
    setViewPort(type);
    setIndex(index);
    setModalVisible(true);
  };

  const inputChange = (val: string) => {
    setComment(val);
  };

  return (
    <div className="common-presenter k-common-vote-panel">
      <div className="vote-panel__btn--wrap">
        <div className="vote-panel__btn--left" onClick={() => voteAction(0, true)}>
          {voteInfo.voteOptions && voteInfo.voteOptions[0].voteDescription}
        </div>
        <div className="vote-panel__btn--pk">
          <img src={pkBtn} alt="" />
        </div>
        <div className="vote-panel__btn--right" onClick={() => voteAction(1, false)}>
          {voteInfo.voteOptions && voteInfo.voteOptions[1].voteDescription}
        </div>
      </div>
      <div className="vote-panel__btn--desc">点击上方按钮，支持我认同的观点！</div>
      <Modal
        title="我的观点"
        okText="发表观点"
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        className="vote-modal"
        maskClosable={false}
      >
        <TextArea
          className="vote-textarea"
          rows={4}
          onChange={e => {
            const { value } = e.target;
            inputChange(value);
          }}
        />
      </Modal>
    </div>
  );
}

export default SFCVotePanel;
